import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Check, X, ShieldCheck } from "lucide-react";

export default function WhitelistApprovePage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState(token ? "loading" : "missing");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    api.get(`/whitelist/approve?token=${encodeURIComponent(token)}`)
      .then((r) => { setData(r.data); setStatus("done"); })
      .catch((e) => {
        setError(e?.response?.data?.detail || e?.message || "approve_failed");
        setStatus("error");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6" data-testid="whitelist-approve-page">
      <div className={`max-w-md w-full border p-6 text-center ${
        status === "done" ? "border-emerald-400/60"
        : status === "error" || status === "missing" ? "border-rose-400/60"
        : "border-amber-400/60"
      } bg-[#0E0E0E]`}>
        <ShieldCheck size={24} className="mx-auto text-amber-300" />
        <div className="mt-2 text-[11px] font-mono uppercase tracking-[0.2em] text-amber-300">
          MINDSTEIN · WHITELIST_APPROVAL
        </div>
        {status === "loading" && (
          <div className="mt-4 text-[12px] font-mono text-zinc-400">APPROVING…</div>
        )}
        {status === "done" && (
          <>
            <Check size={22} className="mx-auto text-emerald-300 mt-3" />
            <div className="mt-2 text-[13px] font-mono uppercase tracking-wider text-emerald-200">
              APPROVED · {data?.submission_name}
            </div>
            <div className="text-[11px] font-mono text-zinc-500 mt-1">kind · {data?.kind}</div>
          </>
        )}
        {(status === "error" || status === "missing") && (
          <>
            <X size={20} className="mx-auto text-rose-300 mt-3" />
            <div className="mt-2 text-[13px] font-mono uppercase tracking-wider text-rose-200">
              {status === "missing" ? "MISSING_TOKEN" : error}
            </div>
          </>
        )}
        <Link to="/" className="mt-4 inline-block text-[11px] font-mono text-zinc-400 hover:text-white">
          BACK_TO_HOME →
        </Link>
      </div>
    </div>
  );
}
